import React from 'react';

const ThresholdManagementIcon = () => {
	return (
		<svg
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
		>
			<path
				d='M20.25 20.25H3.75'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M9.75 3H6C5.58579 3 5.25 3.33579 5.25 3.75V16.5C5.25 16.9142 5.58579 17.25 6 17.25H9.75C10.1642 17.25 10.5 16.9142 10.5 16.5V3.75C10.5 3.33579 10.1642 3 9.75 3Z'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				clipRule='evenodd'
				d='M18.658 13C18.8522 13 19.0147 13.1471 19.0341 13.3404C19.0641 13.6404 19.4161 13.7862 19.6495 13.5953C19.7998 13.4723 20.0188 13.4832 20.1561 13.6205L20.3795 13.8439C20.5168 13.9812 20.5277 14.2002 20.4047 14.3505C20.2138 14.5839 20.3596 14.936 20.6596 14.966C20.8529 14.9853 21 15.1479 21 15.3421V15.658C21 15.8521 20.8529 16.0147 20.6597 16.034C20.3597 16.064 20.2139 16.416 20.4048 16.6494C20.5277 16.7997 20.5168 17.0187 20.3795 17.1559L20.1561 17.3793C20.0188 17.5166 19.7998 17.5276 19.6495 17.4046C19.4161 17.2137 19.0641 17.3595 19.0341 17.6596C19.0147 17.8528 18.8521 18 18.6579 18H18.3421C18.1479 18 17.9853 17.8529 17.966 17.6596C17.936 17.3596 17.5839 17.2138 17.3505 17.4047C17.2003 17.5277 16.9812 17.5168 16.8439 17.3794L16.6206 17.1561C16.4833 17.0188 16.4723 16.7998 16.5953 16.6495C16.7863 16.4161 16.6404 16.064 16.3404 16.034C16.1471 16.0147 16 15.8521 16 15.6579V15.3421C16 15.1479 16.1472 14.9853 16.3404 14.966C16.6405 14.9359 16.7863 14.5839 16.5953 14.3504C16.4724 14.2001 16.4833 13.9811 16.6206 13.8438L16.844 13.6204C16.9813 13.4831 17.2003 13.4722 17.3506 13.5952C17.5839 13.7861 17.936 13.6403 17.966 13.3403C17.9853 13.1471 18.1479 13 18.342 13H18.658ZM18.5 16.5C19.0523 16.5 19.5 16.0523 19.5 15.5C19.5 14.9477 19.0523 14.5 18.5 14.5C17.9477 14.5 17.5 14.9477 17.5 15.5C17.5 16.0523 17.9477 16.5 18.5 16.5Z'
				fill='#2E2E6B'
				fillRule='evenodd'
			/>
			<path
				d='M14.8995 17.25H14.3C13.8582 17.25 13.5 16.8918 13.5 16.45V7.55C13.5 7.10817 13.8582 6.75 14.3 6.75H17.95C18.3918 6.75 18.75 7.10817 18.75 7.55V11.475'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default ThresholdManagementIcon;
